import React from "react";

export function LoadingMessage(): React.ReactElement {

    return (
        <>
            <span>.</span>
            <span>.</span>
            <span>.</span>
        </>
    );
}

